import * as React from "react";

function PenPaintbrushIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M90.57 323.5 394.7 19.32c25-24.998 65.6-24.998 90.6 0l39.4 39.43c3.1 3.12 5.8 6.49 8.2 10.04 16.4 24.84 13.7 58.61-8.2 80.51L220.5 453.4c-1.3 1.3-2.6 1.7-4 3.8-9.6 8.5-21 13.9-33.4 18.4L62.77 511c-8.42 2.5-17.53.2-23.74-6.9-6.21-5.3-8.53-14.4-6.05-22.9l35.39-120.3c4.16-14.1 11.79-27 22.2-37.4zm23.83 50.9-22.96 78.2 78.16-23c5.5-1.9 12.2-5.4 17-10.1L415 191l-62.9-62.9-227.6 229.3c-.6.6-1.2 1.2-1.7 1.9-3.9 4.3-6.7 9.5-8.4 15.1zm207.4 34.3c7.6 31.7 36.1 55.3 70.1 55.3h85.6l-.7-.9c-11.6-16.9-17-38.6-13.7-60 .5-3.6.8-7.3.8-11.1 0-34.9-23.6-62.5-55.3-70.1l37.2-37.2c38.3 19.8 66.1 60.4 66.1 107.3 0 6.2-.5 12.4-1.4 18.4-2.7 17.8 9.3 37.6 27.4 37.6h6c17.7 0 32 14.3 32 32s-14.3 32-32 32h-152c-46.9 0-87.5-26.9-107.3-66.1l37.2-37.2zM136 24l98.7 98.7-33.9 34-98.7-98.76c-12.22-12.18-31.98-12.18-44.16 0-12.18 12.18-12.18 31.94 0 44.16l98.76 98.7-34 33.9L24 136C-6.927 105.1-6.927 54.93 24 24c30.93-30.927 81.1-30.927 112 0z"
  }));
}

const ForwardRef = React.forwardRef(PenPaintbrushIcon);
export default ForwardRef;